/**
 * Fred Martin Collection - Product Global Settings
 * @version 2.0.0 | Build 20250105.1455
 * @author Fred Martin Studio
 * @description Global product page configurations and utilities
 * Custom product handling for Fred Martin Collection
 */

const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}
